import SegmentedControl from './segmented-control';
export type { SegmentedItemOption, SegmentedControlProps } from './segmented-control.types';

export default SegmentedControl;
